export function construirUrlDoCalendarioAloque(baseUrl: string): string {
  if (!baseUrl) return ''

  const url = new URL(baseUrl, obterOrigemPadrao())
  url.hash = '/embed/calendario'
  return url.toString()
}

export function resolverUrlBaseAloqueK8s(
  baseUrl: string | undefined,
  namespace: string
): string {
  if (!baseUrl) return ''
  if (namespace !== 'pontotel' && !namespace.startsWith('alpha')) return baseUrl

  const url = new URL(baseUrl)
  url.pathname = `/${namespace}/timesheet-frontend/`
  url.search = ''
  url.hash = ''
  return url.toString()
}

export function construirUrlDeAutenticacaoAloque(
  baseUrl: string,
  email = '',
  retorno = '/embed/calendario'
): string {
  if (!baseUrl) return ''

  const url = new URL(baseUrl, obterOrigemPadrao())
  const parametros = new URLSearchParams()
  if (email) parametros.set('email', email)
  if (retorno) parametros.set('retorno', retorno)
  parametros.set('automatico', 'true')
  url.hash = `/auth?${parametros.toString()}`
  return url.toString()
}

function obterOrigemPadrao(): string {
  return typeof window === 'undefined' ? 'http://localhost' : window.location.origin
}
